import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';

export type ViewMode = 'list' | 'grid';

interface ViewToggleProps {
  view: ViewMode;
  onChange: (view: ViewMode) => void;
  ariaLabel?: string;
}

export function ViewToggle({ view, onChange, ariaLabel = 'Toggle view mode' }: ViewToggleProps) {
  const handleChange = (event: React.MouseEvent<HTMLElement>, newView: ViewMode | null) => {
    if (newView !== null) {
      onChange(newView);
    }
  };

  const handleButtonClick = (mode: ViewMode) => {
    onChange(mode);
  };

  return (
    <ToggleButtonGroup
      value={view}
      exclusive
      onChange={handleChange}
      aria-label={ariaLabel}
      size="small"
      sx={{
        bgcolor: '#F2F2F2',
        '& .MuiToggleButton-root': {
          border: '1px solid #E5E7EB',
          color: '#4A5565',
          padding: '6px 12px',
          '&.Mui-selected': {
            bgcolor: '#2932E5',
            color: '#FFFFFF',
            '&:hover': {
              bgcolor: '#1E25B8',
            },
          },
          '&:hover': {
            bgcolor: '#E5E7EB',
          },
        },
      }}
    >
      <ToggleButton 
        value="list" 
        aria-label="list view" 
        title="List view"
        onClick={() => handleButtonClick('list')}
      >
        <ViewListIcon fontSize="small" />
      </ToggleButton>
      <ToggleButton 
        value="grid" 
        aria-label="grid view" 
        title="Grid view"
        onClick={() => handleButtonClick('grid')}
      >
        <ViewModuleIcon fontSize="small" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}